"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconGrid = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 24 24",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M4,11.1111111 L11.1111111,11.1111111 L11.1111111,4 L4,4 M4,20 L11.1111111,20 L11.1111111,12.8888889 L4,12.8888889 M12.8888889,20 L20,20 L20,12.8888889 L12.8888889,12.8888889 M12.8888889,4 L12.8888889,11.1111111 L20,11.1111111 L20,4"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconGrid')(IconGrid);